require('./helpers/bundle-manifest').register(JSON.parse("{\"7lpHJ\":\"index.js\",\"jD60Z\":\"web-vitals.92dee9bf.js\",\"iFxUa\":\"index.css\"}"));